import { component } from 'picoapp';


export default component((node, ctx) => {
  if (!customElements.get('scrolling-elements')) {
    customElements.define(
      'scrolling-elements',
      class ScrollingText extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.style.setProperty('display', 'grid');
          if (window.ResizeObserver) {
            new ResizeObserver(this._calcDuration.bind(this)).observe(this);
          }
        }

        _calcDuration(entries) {
          const scrollingSpeed = parseInt(this.getAttribute('scrolling-speed') || 5),
            contentWidth = entries[0].contentRect.width,
            slowFactor = 1 + (Math.min(1600, contentWidth) - 375) / (1600 - 375);

          this.style.setProperty(
            '--scrolling-animation-duration',
            `${((scrollingSpeed * slowFactor * entries[0].target.querySelector('.wrapper').clientWidth) / contentWidth).toFixed(3)}s`
          );
        }
      }
    );
  }
});
